import { combineReducers } from "redux";
import recycleState from "redux-recycle";
import app, { initialState as appInitialState } from "./app";

const rootReducer = combineReducers({
  app: recycleState(app, [], appInitialState)
});

export default rootReducer;
